import axios from "axios";
//import FormData from "form-data";
import {AdminEditBaseFlowValueEndPoint} from "../../../config/AppServerConfig";
import {GlobalConfig} from "./../../../Services/Helper/GlobalConfig";

class AdminBaseEditFlowValueServices {
    static updateAdminBaseFlowValue(id,flowValue) {
        const config = {
            headers: {"Authorization": GlobalConfig.Token}
        };
        return axios.put(AdminEditBaseFlowValueEndPoint + "/" + id,{flowValue}, config);
    }

}

export {AdminBaseEditFlowValueServices};
